// Standard set of clubs a golfer might carry in the bag. Used to populate the
// club-type picker in the swing-data editor. The picker also allows free text,
// so a user can still enter a club that isn't in this list.
export const GOLF_CLUBS: string[] = [
  // Woods
  'Driver',
  '2 Wood',
  '3 Wood',
  '4 Wood',
  '5 Wood',
  '7 Wood',
  '9 Wood',
  '11 Wood',
  'Fairway Wood',
  // Hybrids / rescue
  'Hybrid',
  '2 Hybrid',
  '3 Hybrid',
  '4 Hybrid',
  '5 Hybrid',
  '6 Hybrid',
  '7 Hybrid',
  // Irons
  'Driving Iron',
  'Utility Iron',
  '1 Iron',
  '2 Iron',
  '3 Iron',
  '4 Iron',
  '5 Iron',
  '6 Iron',
  '7 Iron',
  '8 Iron',
  '9 Iron',
  // Wedges
  'Pitching Wedge',
  'Gap Wedge',
  'Approach Wedge',
  'Sand Wedge',
  'Lob Wedge',
  'Ultra Lob Wedge',
  // Specialty
  'Chipper',
  'Putter',
];

// A standard 14-club bag — the clubs always shown in the club-data manager and
// offered as tiles when adding a club. Mirrors iOS `GolfClubs.defaultBag`. Every
// entry is also a member of `GOLF_CLUBS`.
export const DEFAULT_BAG: string[] = [
  'Driver',
  '3 Wood',
  '5 Wood',
  '4 Hybrid',
  '5 Iron',
  '6 Iron',
  '7 Iron',
  '8 Iron',
  '9 Iron',
  'Pitching Wedge',
  'Gap Wedge',
  'Sand Wedge',
  'Lob Wedge',
  'Putter',
];
